import type { ComponentType } from 'react';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { UNSAFE_noExposureExp } from '@atlassian/jira-feature-experiments';
import {
	type FindFieldHelpLinkProps,
	SidebarFindFieldHelpLinkWithEfaEnabled,
} from './field-field-help-efa/index.tsx';
import { SidebarFindFieldHelpLinkToGlobalSettings } from './field-field-help-m2/index.tsx';

const isEfaExperimentExposed = () => {
	const [expConfig] = UNSAFE_noExposureExp('efa_and_project_fields_page_for_tmp');
	return expConfig.get('isEnabled', false);
};

export const SidebarFindFieldHelpLink: ComponentType<FindFieldHelpLinkProps> =
	componentWithCondition(
		isEfaExperimentExposed,
		SidebarFindFieldHelpLinkWithEfaEnabled,
		SidebarFindFieldHelpLinkToGlobalSettings,
	);
